<template>
    <div v-clickaway="closeSlotsTooltip" v-bind="elementProps" @click="toggleSlotsTooltip($event)">
        <span v-if="isToday">
            {{ date.format('D') }}
            <span v-if="!isTablet">{{ $t('pages.referrals.new.microcopy.today') }}</span>
        </span>

        <span v-else>
            {{ date.format('D') }}
        </span>

        <span v-if="checkForActions" class="availability-month-calendar-day__action-dot"></span>

        <template v-if="hasAvailableSlots">
            <div :class="slotClass">
                <span v-if="referralsCount && !isMobileLarge" class="availability-month-calendar-day__label">
                    <span v-if="isTablet">
                        {{ referralsCount }}
                    </span>
                    <span v-else>
                        {{ $tc('pages.referrals.new.microcopy.referrals', referralsCount) }}
                    </span>
                </span>
                <span v-if="slotsCount && !isMobileLarge" class="availability-month-calendar-day__label">
                    <span v-if="isTablet">
                        {{ availableSlotsCount }}
                    </span>
                    <span v-else>
                        {{ $tc('pages.referrals.new.microcopy.slots', availableSlotsCount) }}
                    </span>
                </span>
                <div ref="tooltip" class="appointment-calendar-day__slots--dropdown">
                    <calendar-slots
                        :year="year"
                        :month="month"
                        :day="day"
                        :slots="slots"
                        :isOpen="isSlotsTooltipOpen"
                        :referralsCount="referralsCount"
                        :showCancelled="showCancelled"
                        @emitEvent="emitEvent($event)"
                    ></calendar-slots>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarDayMixin from 'mixins/CalendarDayMixin'
    import CalendarSlots from './AvailibilityMonthCalendarSlots'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [CalendarDayMixin, ScreenSizeDetectionMixin],

        components: {
            CalendarSlots,
        },

        props: {
            slots: { type: Array, required: true },
            referralsCount: { type: Number, required: true },
            showCancelled: { type: Boolean, required: true },
        },

        computed: {
            isToday() {
                const today = dayjs().startOf('day')
                return this.date.$d.toString() === today.$d.toString()
            },
            slotClass() {
                return {
                    'appointment-calendar-day__slots': true,
                    'appointment-calendar-day__slots--multiple': this.slotsCount && this.referralsCount,
                }
            },

            hasAvailableSlots() {
                return this.slotsCount || this.referralsCount
            },

            checkForActions() {
                return (
                    this.slots.filter(
                        (slot) =>
                            slot.referral &&
                            (slot.referral.status === 'CREATED' ||
                                slot.referral.status === 'INSURANCE_AUTH_PENDING' ||
                                slot.referral.status === 'CONSULTATION_NOTES_PENDING'),
                    ).length > 0
                )
            },

            availableSlotsCount() {
                const unavailableSlotsCount = this.slots.filter((slot) => slot.isUnavailable).length
                return this.slots.length - this.referralsCount - unavailableSlotsCount
            },
        },

        watch: {
            month() {
                this.isSlotsTooltipOpen = false
            },
        },
    }
</script>
